import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { select_device_map } from 'shared/map/model/selectors';
import { hideHighlightRings } from 'shared/map/model/slice';
import { a2l } from 'shared/map/lib/utils';
import { HighlightRings } from 'entities/map.highlight-rings/ui';
export const DeviceRings = memo(function DeviceRings(props) {
    const { device_id } = props;
    const map_state = usePartialAppSelector(select_device_map, device_id);
    const _onHideHighlightRings = useAction(hideHighlightRings);
    const onHideHighlightRings = useCallback(() => _onHideHighlightRings({ device_id }), [device_id]);
    if (!map_state?.highlight_rings) {
        return null;
    }
    return (_jsx(HighlightRings, { device_id: device_id, loc: a2l(map_state.highlight_rings.loc), color: map_state.highlight_rings.color, onDone: onHideHighlightRings }));
});
